import { useCallback, useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import Modal from "../../components/generic/Modal";
import { parseError } from "../../utils/shared";
import httpClient from "../../api/httpClient";

const ForgotPasswordModal = ({ onClose }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [form] = Form.useForm();

  const onFinish = useCallback(async (values) => {
    try {
      setIsProcessing(true);
      await httpClient.publicPost("forget-password", {
        type: "forget",
        email: values.email,
      });
      message.success("Forget password link sent successfully.");
      setEmailSent(true);
    } catch (error) {
      parseError(error, true);
    } finally {
      setIsProcessing(false);
    }
  }, []);

  const handleClose = useCallback(() => {
    form.resetFields();
    setEmailSent(false);
    onClose();
  }, []);

  return (
    <Modal
      title="Forgot Password"
      open
      onCancel={handleClose}
      footer={null}
      isProcessing={isProcessing}
      width={"500px"}
    >
      {!emailSent ? (
        <>
          <p style={{ color: "#888", marginBottom: "1.5rem" }}>
            Enter your registered email address and we'll send you a link to
            reset your password.
          </p>

          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please input your email!" },
                { type: "email", message: "Invalid email format!" },
              ]}
            >
              <Input placeholder="Enter your registered email" />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={isProcessing}
                block
              >
                Send Reset Link
              </Button>
            </Form.Item>
          </Form>
        </>
      ) : (
        // Success State
        <div style={{ textAlign: "center", padding: "1rem 0" }}>
          <div style={{ fontSize: "3rem" }}>📩</div>
          <h3>Check your inbox!</h3>
          <p style={{ color: "#888", margin: "16px 0px" }}>
            We've sent a password reset link to your email. Please check your
            inbox and spam folder.
          </p>
          <Button type="primary" block onClick={handleClose}>
            Done
          </Button>
          <Typography.Link
            style={{ display: "block", marginTop: "1rem" }}
            onClick={() => {
              setEmailSent(false);
              form.resetFields();
            }}
          >
            Didn't receive it? Try again
          </Typography.Link>
        </div>
      )}
    </Modal>
  );
};

export default ForgotPasswordModal;
